import React from "react";
import "rc-slider/assets/index.css";
import {pad} from "../utils";
import Measure from "react-measure";

export default class Sunstudy extends React.Component {
    constructor() {
        super();
        this.onMeasured = this.onMeasured.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentView !== this.props.currentView) {
            console.log('NY VIEW!');
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.currentView !== nextProps.currentView) {
            return true;
        }

        if (this.props.currentSlide !== nextProps.currentSlide) {
            return true;
        }

        if (this.props.width !== nextProps.width) {
            return true;
        }

        return false;
    }

    onClick(area) {

    }

    onMeasured(dimensions) {
        console.log('sunstudy MEASURED', dimensions);
        this.props.onSunstudyMeasured(dimensions);
    }


    render() {
        /*if (!this.props.width || !this.props.height || !this.props.currentView) {
            return null;
        }*/

        //return null;

        if (!this.props.currentView) {
            return false;
        }

        console.log('SUNSTUDY render');

        const view = this.props.currentView;
        const keyPrefix = this.props.sunstudy.map_id + '_' + this.props.currentView.slug;

        let images = [], marks = {};
        for (let i = 1; i <= view.nImages; i++) {
            let num = pad('0000', i, true);
            marks[i] = i;
            images.push((
                <img key={keyPrefix + i} alt={'sunstudy'} className={i === this.props.currentSlide ? 'active' : ''}
                     src={`//webservices.carbonwhite.se${view.path}/${num}.jpg`}/>));
        }


        return (
            <Measure
                onMeasure={this.onMeasured}>
                <div className="cw-sunstudy">
                    <div className="cw-sunstudy-images">
                        {images}
                    </div>
                </div>
            </Measure>)
    }
}


// WEBPACK FOOTER //
// ./src/components/Sunstudy.jsx